import { useState } from 'react';

/**
 * The public address of a nota, visible and copyable.
 *
 * An editor's most common next action after reading a draft is sending it to someone who will
 * never open this dashboard. Making them construct the URL from the address bar is the kind of
 * small friction that ends with a screenshot in WhatsApp instead of a link.
 */
export function ShareLink({ path, label = 'Enlace para compartir' }: { path: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${window.location.pathname}#${path}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard needs a secure context. The URL is selectable text either way.
    }
  }

  return (
    <div className="share">
      <span className="share__label">{label}</span>
      <code className="share__url">{url}</code>
      <button type="button" className="share__copy" onClick={copy}>
        {copied ? '✓ Copiado' : 'Copiar'}
      </button>
    </div>
  );
}
